import axios from 'axios';

const instance =  axios.create({
    baseURL: !window.location.host.startsWith("www") ? (process.env.PUBLIC_URL ? process.env.PUBLIC_URL : 'http://37.48.73.100') + '/api' : 'https://www.homepageacademy.rs/api'
});

export default instance;